import React, { useState } from "react";
import { Box } from "@mui/material";
import { StyledMenu, CustomMenuItem } from "./Styled"; // Reuse styles from DropdownMenu
import Status, { ColorTheme } from "../Status"; // Import the Status component
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface CustomDropdownStatusProps {
    menuList: { text: string; id: string }[];
    selectedStatus: string;
    handleOnclickItem: (value: { text: string; id: string }) => void;
    getStatusColorTheme: (status: string) => ColorTheme;
    style?: React.CSSProperties;
    disabled?: boolean;
}

const CustomDropdownStatus = ({
    menuList,
    selectedStatus,
    handleOnclickItem,
    getStatusColorTheme,
    style,
    disabled = false,
}: CustomDropdownStatusProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box style={{ display: "inline-block", ...style }}>
            {/* Status component as the dropdown trigger */}
            <div
                onClick={!disabled ? handleClick : undefined}
                style={{
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.6 : 1,
                }}
            >
                <Status
                    colorTheme={getStatusColorTheme(selectedStatus)}
                    text={menuList.find((item) => item.id === selectedStatus)?.text || "Chờ xử lý"}
                    width="154px"
                    icon={
                        <KeyboardArrowDownIcon
                            style={{
                                rotate: open ? "180deg" : "0deg",
                            }}
                        />
                    }
                />
            </div>

            {/* Dropdown menu */}
            <StyledMenu
                style={{ marginTop: "5px", width: "200px" }}
                id="custom-dropdown-status-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "custom-dropdown-status",
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                slotProps={{
                    paper: {
                        style: {
                            maxHeight: "200px",
                            overflowY: "auto",
                        },
                    },
                }}
            >
                {menuList.map((item) => (
                    <CustomMenuItem
                        key={item.id}
                        onClick={() => {
                            handleOnclickItem(item);
                            handleClose();
                        }}
                    >
                        <Status
                            colorTheme={getStatusColorTheme(item.id)}
                            text={item.text}
                            width="124px"
                        />
                    </CustomMenuItem>
                ))}
            </StyledMenu>
        </Box>
    );
};

export default CustomDropdownStatus;